import { render, staticRenderFns } from "./IconRocket.vue?vue&type=template&id=14bba168&"
import script from "./IconRocket.vue?vue&type=script&lang=js&"
export * from "./IconRocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports